import { render, staticRenderFns } from "./index.vue?vue&type=template&id=0b84716a&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\wwwroot\\dealer-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b84716a')) {
      api.createRecord('0b84716a', component.options)
    } else {
      api.reload('0b84716a', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=0b84716a&", function () {
      api.rerender('0b84716a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/d2-link-btn/index.vue"
export default component.exports